<template>
  <div class="order-content">
    <div class="goods-name">
      <span class="title">{{ orderItem.production_name }}</span>
      <span class="status-tip common" :class="computedClass(orderItem)">
        {{ computedStatus(orderItem) }}
      </span>
    </div>
    <div class="goods-pay-time">
      <span class="label">订单编号: </span>
      <span class="text">{{ orderItem.id }}</span>
    </div>
    <div class="goods-money-apply">
      <span class="label">购买时间: </span
      ><span class="text">{{ formatTime(orderItem.paid_time) }}</span>
    </div>
    <div class="split-line"></div>
    <div class="goods-btn">
      <div class="goods-money-relation">
        <span class="label">实付金额: </span
        ><span class="text pay-money"
          >¥{{ transformMoney(orderItem.pay_amount) }}</span
        >
        <show-icon v-if="showImgIcon">
          <div class="deposit-m-pop">
            定金¥{{
              transformMoney(orderItem.deposit_info.deposit_amount)
            }}，尾款¥{{ transformMoney(orderItem.deposit_info.end_amount) }}
          </div>
          <template slot="reference">
            <img
              class="img-icon"
              src="https://res.pandateacher.com/9A45AV7C1631962088311.png"
              alt=""
            />
          </template>
        </show-icon>
      </div>
      <span
        v-if="orderItem.invoice_status === 0"
        class="apply-billing"
        @click="handleApplyBilling(orderItem)"
        >申请开票</span
      >
      <span
        v-if="orderItem.invoice_status === 1"
        class="billing-detail"
        @click="handleBillingDetail(orderItem)"
        >查看发票</span
      >
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { IOrderList, OrderStatusMap, orderStatusEnum } from '../billingSystem';
import BillingSystemMixins from '../mixin/mixins';
import Toast from 'vant/lib/toast';
import ShowIcon from '../common/ShowIcon.vue';
import 'vant/lib/toast/style';

@Component({
  components: {
    Toast,
    ShowIcon,
  },
})
export default class OrderItem extends Mixins(BillingSystemMixins) {
  @Prop({
    type: Object,
    default: {},
  })
  orderItem!: IOrderList;

  get computedStatus() {
    return ({ order_status }: IOrderList) => {
      if (!order_status) return '';
      return OrderStatusMap[order_status].text;
    };
  }

  get computedClass() {
    return ({ order_status }: IOrderList) => {
      if (!order_status) return '';
      return OrderStatusMap[order_status].class;
    };
  }

  get showImgIcon() {
    return !!this.orderItem.is_end_order;
  }

  async handleApplyBilling({ id }: IOrderList) {
    const {
      data: { order_status },
    } = await window.apis.getInvoiceOrderSingle({
      id,
    });
    if (
      order_status !== orderStatusEnum.refundedSome &&
      order_status !== orderStatusEnum.noState
    ) {
      Toast({
        className: 'billing-toast',
        forbidClick: true,
        message: OrderStatusMap[order_status as orderStatusEnum].toast,
      });
    } else {
      this.handleRouteLinkTo('billingApply', {
        type: 'add',
        id,
      });
    }
  }

  handleBillingDetail({ id }: IOrderList) {
    this.handleRouteLinkTo('billingDetail', {
      OrderId: id,
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../style/index.scss';
.order-content {
  margin-bottom: 24px;
  padding: 32px;
  color: $_base_color;
  font-size: 24px;
  background: $_white_color;
  border-radius: $_base_border_radus;
  .goods-money-relation {
    display: flex;
    align-items: center;
  }
  .img-icon {
    @include wid_hei(48px, 48px);
    display: inline-block;
    vertical-align: bottom;
  }
  .label {
    color: $_label_color;
    font-family: $_reg_famliy;
  }
  .text {
    color: #6e688d;
    font-weight: 500;
    font-family: $_med_famliy;
  }
  .text.pay-money {
    margin: 0 5px;
    color: $_base_color;
    font-weight: 500;
    font-size: 28px;
    font-family: $_med_famliy;
  }
  .goods-name {
    @include flex_layout(center, space-between);
    margin-bottom: $_base_bottom;
    font-weight: 500;
    font-size: 28px;
    .title {
      display: -webkit-box;
      max-width: 420px;
      overflow: hidden;
      text-overflow: -o-ellipsis-lastline;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .status-tip {
      flex-shrink: 0;
      align-self: flex-start;
      font-size: 22px;
    }
  }
  .goods-pay-time {
    margin-bottom: $_base_bottom;
  }
  .goods-btn {
    @include flex_layout(center, space-between);
  }
  .apply-billing,
  .billing-detail {
    padding: 10px 36px;
    font-family: $_reg_famliy;
    background: $_white_color;
    border: 1px solid #6e688d;
    border-radius: 6px;
  }
  .split-line {
    height: 1px;
    margin-top: 24px;
    margin-bottom: 34px;
    background: #e5e3ec;
  }
  .common {
    padding: 4px 12px;
    font-family: $_reg_famliy;
    border-radius: 6px;
  }
  .refunding {
    color: #ff6f79;
    background: rgba(255, 111, 121, 0.1);
  }
  .refund-all {
    color: #20ab4c;
    background: rgba(32, 171, 76, 0.1);
  }
  .refund-some {
    color: #20ab4c;
    background: rgba(32, 171, 76, 0.1);
  }
  .overdue {
    color: #ff6f79;
    background: rgba(255, 111, 121, 0.1);
  }
}
</style>

<style lang="scss">
.billing-toast {
  max-width: 586px;
  padding: 24px;
  color: #fff;
  font-size: 28px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 16px;
}
.deposit-m-pop {
  padding: 10px 20px;
  color: rgb(90, 90, 90);
  text-align: center;
  border: 1px solid rgba(255, 0, 0, 0);
  border-radius: 5px;
  box-shadow: 0px 2px 20px 0px rgba(170, 170, 170, 55);
}
</style>